
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    quantity: { type: Number, default: 1 },
  },
});
